<template>
	<div class="player-card-details">
		<Dialog v-if="isAgentAdministrator" :header="playerData.Name" :visible.sync="displayDialog">
			<p><strong>PlayerId: </strong>{{playerData.Id}}</p>
			<p v-if="playerData.Email"><strong>{{$t('Email')}}: </strong>{{playerData.Email}}</p>
			<p v-if="playerData.PhoneNumber"><strong>{{$t('Phone')}}: </strong>{{playerData.PhoneNumber}}</p>
			<p v-if="playerData.Address"><strong>{{$t('address')}}: </strong>{{playerData.Address.FullAddress}}</p>
			<p v-if="playerData.Owner"><strong>{{$t('PlayerFrom')}}: </strong>{{playerData.Owner}}</p>
		</Dialog>
		<div class="p-grid p-nogutter">
			<div class="p-col-12 p-lg-4" style="margin-bottom: 1.5em; ">
				<PictureBox v-if="playerData.UserImageUrl" ref="avatar" :initial-image="commonService.getCDNImageUrl(playerData.UserImageUrl)" :imgWidth="150" :TLWebFormat="!isTransferPlayer" :isEditable="false" typeOfPicture="player" />
			</div>
			<div class="p-col-12 p-lg-8">
				<div class="p-grid p-nogutter">
					<div class="p-col-12 player-card-data">
						<div class="player-card-title" @click="toogleOverlayInfo" :style="(authService.getUserRole() == $agentTirolibre) ? 'cursor: pointer' : ''">{{playerData.Name}}</div>
						<div class="player-card-subtitle">
							<template>
								<CountryFlag :country="playerData.Nationality" />
								<span v-if="playerData.Address && playerData.Address.Region" style="vertical-align: middle"> / {{$t(playerData.Address.Region)}}</span>
							</template>
						</div>
					</div>
					<div class="p-col-6 player-card-data">
						<div class="player-card-info">
							<strong>{{$t('Role')}}</strong>
							<p v-if="playerData.Roles != null && playerData.Roles.length > 0">{{enumService.getEnumName(enumService.getRoleEnum(), playerData.Roles[0].RoleEnumId)}}</p>
							<strong>{{$t('Category')}}</strong>
							<p v-if="authService.getUserRole() == $agentStandard || isTransferPlayer">{{enumService.getEnumName(enumService.getCategoryLevelEnum(), lastCategory)}}</p>
							<p v-else>{{enumService.getEnumName(enumService.getCategoryEnum(), lastCategory)}}</p>
							<strong>{{$t('Salary')}}</strong>
							<p v-if="playerData.ResearchOptions != null && playerData.ResearchOptions.Refund != null && playerData.ResearchOptions.Refund > 4">{{commonService.numberWithDots(playerData.ResearchOptions.Refund)}} €</p>
							<p v-else-if="playerData.ResearchOptions != null && playerData.ResearchOptions.Refund != null && playerData.ResearchOptions.Refund <= 4">{{enumService.getEnumName(enumService.getRefundRangeEnum(), playerData.ResearchOptions.Refund)}}</p>
						</div>
					</div>
					<div class="p-col-6 player-card-data">
						<div class="player-card-info">
							<strong>{{$t('Class')}}</strong>
							<p v-if="playerData.BornDate != null">{{playerData.BornDate.split("-")[0]}}</p>
							<strong v-if="actualStatus == $t('Unattached')">{{$t('Status')}}</strong>
							<strong v-else>{{$t('Club')}}</strong>
							<p>{{actualStatus}}</p>
							<strong>{{$t('HeightNoCM')}}</strong>
							<p>{{playerData.Heigth}}</p>
						</div>
					</div>
					<div class="p-col-6 player-card-data">
						<a v-if="playerData.ExternalLink" :href="playerData.ExternalLink" target="_blank">
							<img src="@/assets/images/transfermarkt_icon.jpg" style="border-radius: 15%" />
						</a>
						<img v-else src="@/assets/images/transfermarkt_icon.jpg" style="border-radius: 15%" />
					</div>
					<!-- <div class="p-col-6 player-card-data">
						<a v-if="playerData.PhoneNumber && authService.getUserId()" :href="commonService.getWhatsappUrl(playerData.PhoneNumber, 'Ciao')" target="_blank">
							<img src="@/assets/images/whatsapp_icon.png" style="border-radius: 15%" width="32" height="32" />
						</a>
						<img v-else src="@/assets/images/whatsapp_icon_disabled.png" style="border-radius: 15%" width="32" height="32" />
					</div> -->
				</div>
			</div>
			<div class="p-col-12">
				<p v-if="(isAgentAdministrator || isAgentPremium) && playerData.Name"><strong>{{$t('LinkToShare')}}: </strong>{{commonService.getPublicPlayerReportUrlToShare(playerData.Id, playerData.Name)}}</p>
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";
import CountryFlag from "@/components/CountryFlag";
import EnumService from "@/service/EnumService";
import AuthService from "@/service/AuthService";
import PictureBox from "@/components/PictureBox";
import PlayerService from "@/service/PlayerService";
import AgentService from "@/service/AgentService";
import Vue from "vue";

export default {
	components: {
		CountryFlag,
		PictureBox,
	},
	props: ["playerData", "isTransferPlayer"],
	data: function () {
		return {
			isAgentAdministrator: false,
			isAgentPremium: false,
			displayDialog: false,
		};
	},
	commonService: null,
	enumService: null,
	authService: null,
	playerService: null,
	agentService: null,
	created() {
		this.commonService = new CommonService();
		this.enumService = new EnumService();
		this.authService = new AuthService();
		this.playerService = new PlayerService();
		this.agentService = new AgentService();

		if (
			this.authService.getUserProfile() == Vue.prototype.$agentProfileId
		) {
			this.agentService.getAgentRoles(this.authService.getUserId()).then(
				(res) => {
					if (res.data.includes(Vue.prototype.$administrator)) {
						this.isAgentAdministrator = true;
					}
					if (res.data.includes(Vue.prototype.$agentPremium)) {
						this.isAgentPremium = true;
					}
				},
				function (err) {}
			);
		}
	},
	computed: {
		actualStatus: {
			get() {
				return this.playerData.Experiences != null &&
					this.playerData.Experiences.length > 0 &&
					this.playerData.Experiences[0].TeamName != null &&
					this.playerData.Experiences[0].TeamName != "Without Club"
					? this.playerData.Experiences[0].TeamName
					: this.$t("Unattached");
			},
		},
		lastCategory: {
			get() {
				if (this.playerData.LastCategory == 0) {
					for (
						var i = 0;
						i < this.playerData.Experiences.length;
						i++
					) {
						if (this.playerData.Experiences[i].Division != null)
							return this.playerData.Experiences[i].Division;
					}
				}

				return this.playerData.LastCategory;
			},
		},
	},
	methods: {
		toogleOverlayInfo(event) {
			let self = this;
			if (
				this.authService.getUserRole() == Vue.prototype.$agentTirolibre
			) {
				this.playerService.getPlayerOwner(this.playerData.Id).then(
					(res) => {
						self.playerData.Owner = res.data;
						self.displayDialog = true;
					},
					function (err) {
						self.displayDialog = true;
					}
				);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.player-card-details {
	> .p-grid {
		border: 1px solid #b3c2ca;
		border-radius: 3px;
		margin: 0.3em;
		text-align: center;
		padding: 2em 0 2.25em 0;
	}
}

.player-card-data {
	.player-card-title {
		font-weight: 700;
		font-size: 20px;
		margin-top: -10px;
	}

	.player-card-subtitle {
		margin: 0 0 0.5em 0;
	}

	.player-card-info p {
		margin: 0.1em 0 0.5em 0;
	}
}
</style>